import Api from 'utils/api'

export const deleteData = (model: string, pk: string | number) => Api.delete([model, pk])

export const fetchData = (model: string, pk: string | number, payload?: Record<string, unknown>) => Api.get([model, pk], payload)

export const patchData = (model: string, pk: string | number, payload: Record<string, unknown>) => Api.patch([model, pk], payload)

export const postData = (model: string, pk: string | number, suffix: string, payload: Record<string, unknown>) =>
  Api.post([model, pk, suffix], payload)
